import React, { InputHTMLAttributes } from "react";
import { Button } from "reactstrap";

type SearchFieldProps = {
  id: string;
  label?: string;
  placeHolder?: string;
  ariaLabel: string;
  classNames?: string;
  wrapperClassNames?: string;
  disabled?: boolean;
  isFieldFullWidth?: boolean;
  searchBtn?: boolean;
  size?: number;
  qm?: boolean;
  onChange?: any;
  onKeyUp?: any;
  refAttr?: any;
  value?: any;
  inputAttributes?: InputHTMLAttributes<any>;
  results?: any;
  shouldAutoFocus?: boolean;
  errorMsg?: string;
  validate?: string;
};

export const SearchField = ({
  id,
  label,
  placeHolder,
  ariaLabel,
  classNames,
  wrapperClassNames,
  disabled,
  isFieldFullWidth,
  searchBtn,
  size,
  qm,
  onChange,
  onKeyUp,
  refAttr,
  value,
  inputAttributes,
  results,
  errorMsg,
  validate,
}: SearchFieldProps) => {
  return (
    <div
      className={
        "form-field search-field-address"
      }
    >
      {label && (
        <label htmlFor={id} className="text">
          {label}
        </label>
      )}
      <div
        id={"search-field-wrapper"}
        className={
          "search-field-wrapper "
        }
      >
        <input
          id={id}
          name={id}
          type="search"
          placeholder={placeHolder}
          size={size}
          autoComplete="off"
          aria-label={ariaLabel}
          disabled={disabled}
          data-qm-allow={qm}
          onChange={onChange}
          onKeyUp={onKeyUp}
          ref={refAttr}
          value={value}
          data-validate={validate}
          className={classNames}
          {...inputAttributes}
        />
        {searchBtn && (
          <Button
            variation={"secondary"}
            classes={"search-field-btn"}
            label={"Search"}
          />
        )}
      </div>
      {errorMsg && (
        <span id={"form-message-error-" + id} className="form-message">
          {errorMsg}
        </span>
      )}
      {results}
    </div>
  );
};
